// src/shared/services/user-cache.ts
export interface CachedUser {
  name: string;
  experienceLevel: string;
  lastUpdate: number;
}

export class UserCache {
  private static STORAGE_KEY = "bmc_user_cache";

  /**
   * Guarda los datos del usuario en localStorage.
   */
  public static save(user: CachedUser): void {
    try {
      if (!user || !user.name) {
        return;
      }
      user.lastUpdate = new Date().getTime();
      localStorage.setItem(UserCache.STORAGE_KEY, JSON.stringify(user));
    } catch (e) {
      // Ignoramos errores de localStorage (por ejemplo en modo privado)
    }
  }

  /**
   * Carga los datos del usuario desde localStorage.
   */
  public static load(): CachedUser | null {
    try {
      var raw = localStorage.getItem(UserCache.STORAGE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.name) return null;

      // Validamos campos mínimos
      return {
        name: parsed.name,
        experienceLevel: parsed.experienceLevel || "",
        lastUpdate: parsed.lastUpdate || 0,
      };
    } catch (e) {
      return null;
    }
  }

  /**
   * Limpia la caché del usuario.
   */
  public static clear(): void {
    try {
      localStorage.removeItem(UserCache.STORAGE_KEY);
    } catch (e) {
      // Ignorar
    }
  }

  /**
   * Devuelve true si hay usuario guardado en caché.
   */
  public static exists(): boolean {
    return UserCache.load() !== null;
  }
}
